/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Badge_CarryoverInputs */

const en_badge_carryover = /** @type {(inputs: Badge_CarryoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carryover`)
};

/**
* | output |
* | --- |
* | "Carryover" |
*
* @param {Badge_CarryoverInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const badge_carryover = /** @type {((inputs?: Badge_CarryoverInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_CarryoverInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_badge_carryover(inputs)
});